import React from 'react';
import { Bell, LogOut, User as UserIcon } from 'lucide-react';
import { Monitor } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "../ui/dropdown-menu";

interface FacultyTopNavProps {
    user: any;
    handleLogout: () => void;
}

const FacultyTopNav: React.FC<FacultyTopNavProps> = ({ user, handleLogout }) => {
    const navigate = useNavigate();

    const userInitials = user?.nickname?.substring(0, 2).toUpperCase() || 'FU';
    const userName = user?.name || 'Faculty User';
    const userRole = 'FACULTY MEMBER';

    return (
        <div className="faculty-portal">
            <div className="top">
                <div className="top-l">
                    <div className="logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                        <img src="/Vyudi-Logo.png" alt="Vyudi Logo" style={{ height: '32px' }} />
                    </div>
                    <div className="top-div"></div>
                    <div className="top-tag">PARTNER PORTAL</div>
                </div>

                <div className="top-r">
                    <div className="top-inst">
                        <Link to="/" className="top-inst-pill">
                            <Monitor size={14} />
                            <span>Eastlake Academy</span>
                        </Link>
                    </div>

                    <button className="top-noti">
                        <Bell size={14} />
                        <span>Notifications</span>
                    </button>

                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <div className="top-user" style={{ cursor: 'pointer' }}>
                                <div className="top-av-wrap">
                                    <div className="top-av">{userInitials}</div>
                                </div>
                                <div className="top-u-info">
                                    <div className="top-nm">{userName}</div>
                                    <div className="top-rl">{userRole}</div>
                                </div>
                            </div>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end" className="w-64 bg-white p-2">
                            <DropdownMenuLabel className="font-normal">
                                <div className="px-2 py-1 flex flex-col space-y-1">
                                    <p className="text-sm font-semibold text-gray-900 leading-none">{user?.name}</p>
                                    <p className="text-xs text-gray-500 leading-none truncate">{user?.email}</p>
                                </div>
                            </DropdownMenuLabel>
                            <DropdownMenuSeparator />
                            <DropdownMenuItem asChild className="cursor-pointer">
                                <Link to="/profile" className="flex items-center w-full">
                                    <UserIcon size={16} className="mr-2" />
                                    <span>Profile</span>
                                </Link>
                            </DropdownMenuItem>
                            <DropdownMenuSeparator />
                            <DropdownMenuItem onClick={handleLogout} className="text-red-600 focus:text-red-700 cursor-pointer">
                                <LogOut size={16} className="mr-2" />
                                <span>Logout</span>
                            </DropdownMenuItem>
                        </DropdownMenuContent>
                    </DropdownMenu>
                </div>
            </div>
        </div>
    );
};

export default FacultyTopNav;
